<template>
  <div class="addressfoot">
    <div class="row flex-row-reverse justify-content-between align-item-center">
      <div class="text-center" :class="out_stock?'out_stock':'col-md-5 col-lg-6'">
        <button
          class="secondary_title"
          :class="{'checkout_active':active,'nothing':nothing}"
          @click="!active&&!nothing&&toNextApi()"
        >{{toNext}}</button>
      </div>
      <div class="col-md-6 text-md-left text-center align-item-center">
        <a  :href="href" v-html="hint"></a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["toNext", "toPrev", "toshipping", "nothing", "out_stock"],
  data() {
    return {
      active: false,
      href:"",
      hint:"",
      tip:""
    };
  },
  methods: {
    toNextApi() {
      this.$emit("toNextApi");
    }
  },
  beforeMount(){
    switch (this.toPrev) {
      case 'cart':
        this.href='/cart';
        this.tip = this.$t('shopping.return_cart');
        break;
      case 'information':
        this.href=this.replaceSearch('step','contact_information');
        this.tip = this.$t('shopping.return_information');
        break;
      case 'shipping':
        this.href=this.replaceSearch('step','shipping_method');
        this.tip=this.$t('shopping.return_shipping')
        break;
      default:
        this.href=this.replaceSearch('step','contact_information');
        this.tip = this.$t('shopping.return_information');
        break;
    }
    this.hint='&lt; ' + this.tip;
  }
};
</script>
<style scoped lang='scss'>
.addressfoot {
  margin-top: 15px;
  button {
    font-size: 14px;
    padding: 20px 24px;
    width: 100%;
    border: none;
    background: #0f88a7;
    color: #f7f7f7;
    font-weight: 500;
    border-radius: 5px;

    span {
      word-break: break-all;
    }
  }
  .nothing {
    background-color: #cccc !important;
    color: #fff !important;
    cursor: default;
  }
  .checkout_active {
    position: relative;
    color: #0f88a7 !important;
    &::after {
      content: "";
      display: block;
      width: 24px;
      height: 24px;
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: -12px;
      margin-top: -12px;
      border-radius: 50%;
      border: 3px solid #fff;
      border-top-color: transparent;
      -webkit-animation: spin 1s infinite linear;
      -moz-animation: spin 1s infinite linear;
      -o-animation: spin 1s infinite linear;
      animation: spin 1s infinite linear;
      @-webkit-keyframes spin {
        0% {
          -webkit-transform: rotate(0deg);
          -moz-transform: rotate(0deg);
          -ms-transform: rotate(0deg);
          -o-transform: rotate(0deg);
          transform: rotate(0deg);
        }
        100% {
          -webkit-transform: rotate(360deg);
          -moz-transform: rotate(360deg);
          -ms-transform: rotate(360deg);
          -o-transform: rotate(360deg);
          transform: rotate(360deg);
        }
      }
      @-moz-keyframes spin {
        0% {
          -webkit-transform: rotate(0deg);
          -moz-transform: rotate(0deg);
          -ms-transform: rotate(0deg);
          -o-transform: rotate(0deg);
          transform: rotate(0deg);
        }
        100% {
          -webkit-transform: rotate(360deg);
          -moz-transform: rotate(360deg);
          -ms-transform: rotate(360deg);
          -o-transform: rotate(360deg);
          transform: rotate(360deg);
        }
      }
      @-ms-keyframes spin {
        0% {
          -webkit-transform: rotate(0deg);
          -moz-transform: rotate(0deg);
          -ms-transform: rotate(0deg);
          -o-transform: rotate(0deg);
          transform: rotate(0deg);
        }
        100% {
          -webkit-transform: rotate(360deg);
          -moz-transform: rotate(360deg);
          -ms-transform: rotate(360deg);
          -o-transform: rotate(360deg);
          transform: rotate(360deg);
        }
      }
      @keyframes spin {
        0% {
          -webkit-transform: rotate(0deg);
          -moz-transform: rotate(0deg);
          -ms-transform: rotate(0deg);
          -o-transform: rotate(0deg);
          transform: rotate(0deg);
        }
        100% {
          -webkit-transform: rotate(360deg);
          -moz-transform: rotate(360deg);
          -ms-transform: rotate(360deg);
          -o-transform: rotate(360deg);
          transform: rotate(360deg);
        }
      }
    }
  }

  a {
    height: 61px;
    line-height: 61px;
    text-decoration: none;
    color: #0f88a7;
    font-size: 14px;
  }
}
@media screen and (max-width: 750px) {
  .out_stock {
    width: 100% !important;
  }
}
</style>